import { Button, Flex, Icon, theme, Typography } from '@fe-toolkit/web-components/ssr'
import { EVisitType } from '@giffgaff/broadband-common'

type Props = {
  visitType: EVisitType
  linkText: string
  onLearnMoreClick: (visitType: EVisitType) => void
}

const LearnMoreButton = ({ visitType, linkText, onLearnMoreClick }: Props) => {
  return (
    <Button
      isFullWidth
      sx={{ width: '100%', marginBottom: theme.spacing.small }}
      variant="link"
      onClick={() => onLearnMoreClick(visitType)}
    >
      <Flex sx={{ alignItems: 'center', justifyContent: 'space-between' }}>
        <Typography as="span" color={'linkBlue'} variant="speakUp">
          {linkText}
        </Typography>
        <Icon color={theme.colors.linkBlue} height={theme.spacing.small} iconKey="Info" width={theme.spacing.small} />
      </Flex>
    </Button>
  )
}

export default LearnMoreButton
